// extracted by mini-css-extract-plugin
export default {"container":"style_container__GxjDf","backgroundImg":"style_backgroundImg__WW80n","titleBox":"style_titleBox__FQzBX"};